import * as angular from 'angular';
import { config } from 'angular/utils/config';

export interface NetworkPointResource
    extends ng.resource.IResourceClass<ng.resource.IResource<NetworkPointDto>> {
    get: ng.resource.IResourceMethod<ng.resource.IResource<NetworkPointDto>>;
    isFavorite: ng.resource.IResourceMethod<ng.resource.IResource<boolean>>;
    disfavor: ng.resource.IResourceMethod<ng.resource.IResource<void>>;
    favor: ng.resource.IResourceMethod<ng.resource.IResource<void>>;
    favorMany: ng.resource.IResourceMethod<ng.resource.IResource<void>>;
    favorites: ng.resource.IResourceMethod<
        ng.resource.IResource<NetworkPointDto[]>
    >;
    favoritesPage: ng.resource.IResourceMethod<
        ng.resource.IResource<DataPageDto<NetworkPointDto>>
    >;
    queryQuickFilters: ng.resource.IResourceMethod<
        ng.resource.IResource<QuickFilterDto[]>
    >;
    addQuickFilter: ng.resource.IResourceMethod<ng.resource.IResource<void>>;
    deleteQuickFilter: ng.resource.IResourceMethod<ng.resource.IResource<void>>;
    findNetworkPoints: ng.resource.IResourceMethod<
        ng.resource.IResource<DataPageDto<NetworkPointDto>>
    >;
    findBundleSituationForBundlePoint: ng.resource.IResourceMethod<
        ng.resource.IResource<BundleDto>
    >;
    findRelatedBundlesForNetworkPoint: ng.resource.IResourceMethod<
        ng.resource.IResource<NetworkPointSimpleDto[]>
    >;
    capacityCategories: ng.resource.IResourceMethod<
        ng.resource.IResource<String[]>
    >;
    getConfiguration: ng.resource.IResourceMethod<
        ng.resource.IResource<NetworkPointConfigurationDto>
    >;
    possibleTargetCapacityCategoriesForIncremental: ng.resource.IResourceMethod<
        ng.resource.IResource<String[]>
    >;
    saveTargetCapacityCategoryForIncremental: ng.resource.IResourceMethod<
        ng.resource.IResource<void>
    >;
    markets: ng.resource.IResourceMethod<ng.resource.IResource<String[]>>;
    geo: ng.resource.IResourceMethod<
        ng.resource.IResource<NetworkPointGeoDto[]>
    >;
    generateXml: ng.resource.IResourceMethod<
        ng.resource.IResource<FallbackUploadResponseDto>
    >;
    uploadAsXML: ng.resource.IResourceMethod<
        ng.resource.IResource<FallbackUploadResponseDto>
    >;
    save: ng.resource.IResourceMethod<ng.resource.IResource<NetworkPointDto>>;
    update: ng.resource.IResourceMethod<ng.resource.IResource<NetworkPointDto>>;
    createIntraTsoBundle: ng.resource.IResourceMethod<
        ng.resource.IResource<BundleChangeRequestDto>
    >;
    getSpecificConditions: ng.resource.IResourceMethod<
        ng.resource.IResource<SpecificConditionDto>
    >;
    saveSpecificConditions: ng.resource.IResourceMethod<
        ng.resource.IResource<SpecificConditionDto>
    >;
    getCapacityPools: ng.resource.IResourceMethod<
        ng.resource.IResource<CapacityPoolDto[]>
    >;
    // saveSpecificConditions(param: { id: number; setting: string }, param2: {value: SelectionPossibility}, param3: (res) => void, param4: (err) => void): void;
}

angular.module('app').factory('NetworkPoint', networkPointResource);

/**
 * Query network points with modes "favorites", "all" or "filtered".
 *
 * @param $resource
 * @param API_URL
 * @returns {*}
 */
function networkPointResource($resource, API_URL) {
    return $resource(
        API_URL.NETWORK_POINTS,
        {
            mode: '@mode',
            infix: '@infix',
            favorites: '@favorites',
            favoritesOf: '@favoritesOf'
        },
        {
            get: {
                url: API_URL.NETWORK_POINTS + ':id',
                params: {
                    id: '@id'
                }
            },
            isFavorite: {
                url: API_URL.NETWORK_POINTS + 'isFavorite/:identifierOrName',
                params: {
                    identifierOrName: '@identifierOrName'
                }
            },
            disfavor: {
                method: 'DELETE',
                url: API_URL.NETWORK_POINTS + 'favorites/:id',
                params: {
                    id: '@id'
                }
            },
            favor: {
                method: 'PUT',
                url: API_URL.NETWORK_POINTS + 'favorites/:id',
                params: {
                    id: '@id'
                }
            },
            favorMany: {
                method: 'POST',
                url: API_URL.NETWORK_POINTS + 'favorites'
            },
            favorites: {
                method: 'GET',
                url: API_URL.NETWORK_POINTS + 'favorites',
                isArray: true
            },
            favoritesPage: {
                method: 'GET',
                url: API_URL.NETWORK_POINTS + 'favorites/page'
            },
            queryQuickFilters: {
                method: 'GET',
                url: API_URL.NETWORK_POINTS + 'quickFilters',
                isArray: true
            },
            addQuickFilter: {
                method: 'PUT',
                url: API_URL.NETWORK_POINTS + 'quickFilters'
            },
            deleteQuickFilter: {
                method: 'DELETE',
                url: API_URL.NETWORK_POINTS + 'quickFilters/:name',
                param: {
                    name: '@name'
                }
            },
            findNetworkPoints: {
                method: 'GET',
                url: API_URL.NETWORK_POINTS + 'findNetworkPoints',
                isArray: false
            },
            findBundleSituationForBundlePoint: {
                method: 'GET',
                url: API_URL.NETWORK_POINTS + ':refId/bundle-situation'
            },
            findRelatedBundlesForNetworkPoint: {
                method: 'GET',
                url: API_URL.NETWORK_POINTS + ':refId/related-bundles',
                isArray: true
            },
            capacityCategories: {
                method: 'GET',
                url: API_URL.NETWORK_POINTS + 'capacityCategories',
                isArray: true
            },
            getConfiguration: {
                method: 'GET',
                url: API_URL.NETWORK_POINTS + ':id/configuration',
                params: {
                    id: '@id'
                }
            },
            possibleTargetCapacityCategoriesForIncremental: {
                method: 'GET',
                url:
                    API_URL.NETWORK_POINTS +
                    ':id/possible-incremental-target-capacity-categories',
                isArray: true,
                params: {
                    id: '@id'
                }
            },
            saveTargetCapacityCategoryForIncremental: {
                method: 'POST',
                url:
                    API_URL.NETWORK_POINTS +
                    ':id/incremental-target-capacity-category',
                params: {
                    id: '@id'
                }
            },
            markets: {
                method: 'GET',
                url: API_URL.NETWORK_POINTS + 'markets',
                isArray: true
            },
            geo: {
                method: 'GET',
                url: API_URL.NETWORK_POINTS + 'geo',
                isArray: true
            },
            generateXml: {
                method: 'POST',
                url: API_URL.NETWORK_POINTS + 'as-xml'
            },
            uploadAsXML: {
                method: 'POST',
                url: config.monolithApi + '/networkPoints',
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            },
            update: {
                method: 'POST',
                url: config.monolithApi + '/networkPoints/:id'
            },
            createIntraTsoBundle: {
                method: 'POST',
                url: config.monolithApi + '/networkPoints/intra-tso-bundle'
            },
            getSpecificConditions: {
                method: 'GET',
                url: API_URL.NETWORK_POINTS + ':id/specificConditions',
                isArray: true,
                params: {
                    id: '@id'
                }
            },
            saveSpecificConditions: {
                method: 'POST',
                url: API_URL.NETWORK_POINTS + ':id/specificConditions',
                params: {
                    id: '@id'
                }
            },
            getCapacityPools: {
                method: 'GET',
                url: API_URL.DIRECT_FCFS_CAPACITY_DATA + ':id/capacity-pools',
                params: {
                    id: '@id'
                },
                isArray: true
            }
        }
    );
}
